import React from 'react';
import { useAuth } from '../AuthContext';
import CreateJob from './CreateJob';
import JobList from './JobList';
import SendVerificationEmail from './SendVerificationEmail';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
    const { userToken, userVerified, userRole, userId } = useAuth();

    if (!userToken) {
        return <div id="content-pane">
            <div className="overview app_intro">
                <div className='splash_box'>MHC Attention for <span className='blue-text'>presentation scoring</span> and HLA-E analysis<span className='blue-text'>.</span></div>
                    <p>
                        <b>MHC Attention</b> is an updated model for predicting MHC Class I presentation released by Vcreate in April 2026.
                        It has leading performance across human class I alleles, and includes a specialized submodel finetuned on Vcreate&apos;s HLA-E presentation data.
                        See the <a href="https://www.biorxiv.org/content/10.64898/2026.06.08.730987v1" target="_blank" rel="noreferrer">bioRxiv preprint</a> for more details.
                    </p>
                    <div className='sign_up_hero'>
                        <Link to="/signin"><button>Sign In</button></Link>
                        <Link to="/signup"><button>Create Account</button></Link>
                    </div>
                </div>
            </div>;
    }

    if (!userVerified) {
        return <div id="content-pane">
                <SendVerificationEmail></SendVerificationEmail>
            </div>;
    }

    if (userRole === "Unapproved") {
        return <div id="content-pane">
                <h3>Please contact us for account verification</h3>
                <p className='approval'>Your email address is not associated with an institution preapproved to use this service. Please contact us at <a href="mailto:contact@vcreate.io">contact@vcreate.io</a> and provide your name and affiliation so that we can manually verify your account.</p>
            </div>;
    }

    return (
        <div id="content-pane">
            <CreateJob />
            {userId && <JobList userId={userId} />}
        </div>
    );
};

export default Home;
